'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = runValidatorsOnSchema;

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _codevTraverse = require('codev-traverse');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var flattenObjTill = function flattenObjTill(stopKey) {
  return function (obj) {
    var go = function go(obj_) {
      return _ramda2.default.chain(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        if (_ramda2.default.type(v) === 'Object' || _ramda2.default.type(v) === 'Array') {
          if (k !== stopKey) {
            return _ramda2.default.map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                  k_ = _ref4[0],
                  v_ = _ref4[1];

              return [k + '.' + k_, v_];
            }, go(v));
          }
        }
        return [[k, v]];
      }, _ramda2.default.toPairs(obj_));
    };

    return _ramda2.default.fromPairs(go(obj));
  };
};

var RESULT_KEY = '__validationResult__';
// TODO support async validator
var validation = function validation(schema) {
  return function (ctx) {
    return function (next) {
      return function () {
        var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(value) {
          var validator, action, message, result;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  validator = schema.validator;
                  action = ctx.action;

                  // missing fields are allowed in `update` action

                  if (!(action === 'update' && value === undefined)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt('return', value);

                case 4:
                  if (validator) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 7;
                  return next(value);

                case 7:
                  return _context.abrupt('return', _context.sent);

                case 8:
                  _context.next = 10;
                  return validator(value, ctx);

                case 10:
                  message = _context.sent;

                  if (message) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 14;
                  return next(value);

                case 14:
                  return _context.abrupt('return', _context.sent);

                case 15:
                  result = { message: message, value: value, schema: schema };
                  _context.t0 = _extends;
                  _context.t1 = _defineProperty({}, RESULT_KEY, result);
                  _context.next = 20;
                  return next(value);

                case 20:
                  _context.t2 = _context.sent;
                  return _context.abrupt('return', (0, _context.t0)(_context.t1, _context.t2));

                case 22:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined);
        }));

        return function (_x) {
          return _ref5.apply(this, arguments);
        };
      }();
    };
  };
};

var toValidationMessage = function toValidationMessage(_ref6) {
  var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      result = _ref7[1];

  var path = _ramda2.default.pipe(_ramda2.default.split('.'), _ramda2.default.reject(_ramda2.default.equals(RESULT_KEY)))(key);

  return _extends({ path: path }, result);
};

// ISSUE add `server`, `user` in context?
function runValidatorsOnSchema(schema) {
  var tester = (0, _codevTraverse.traverse)(schema)(validation)({});
  return function () {
    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(value) {
      var result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return tester(value);

            case 2:
              result = _context2.sent;
              return _context2.abrupt('return', _ramda2.default.pipe(flattenObjTill(RESULT_KEY), _ramda2.default.reject(_ramda2.default.isNil), _ramda2.default.toPairs, _ramda2.default.map(toValidationMessage))(result));

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x2) {
      return _ref8.apply(this, arguments);
    }

    return validate;
  }();
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/validation/runValidatorsOnSchema.js
// module id = 1761
// module chunks = 0